import React from 'react';
import { List } from 'semantic-ui-react';
import Security from '../../utils/Security';

const ExpertInfo = ({ name, title, organization }) => {
  const description = Security.isDoubleBlinded() ? `${name}` : `${name} | ${title} at ${organization}`;
  return (
    <List.Item>
      <List.Icon name="user" />
      <List.Content>
        <List.Header>{'Expert: '}</List.Header>
        <List.Description>{description}</List.Description>
      </List.Content>
    </List.Item>
  );
};

export default ExpertInfo;
